import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/styles.scss";
import App from "./App";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import MedilineTheme from "./theme/MedilineTheme";
import reportWebVitals from "./reportWebVitals";
import { AuthState } from "./context/AuthState";
import { ReportsState } from "./context/Reports";
import ToastProvider from "./context/Toast/ToastProvider";
import { ProSidebarProvider } from "react-pro-sidebar";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import 'dayjs/locale/es';
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={MedilineTheme}>
      <AuthState>
        <ReportsState>
          <ToastProvider>
            <CssBaseline />
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
              <ProSidebarProvider>
                <App />
              </ProSidebarProvider>
            </LocalizationProvider>
          </ToastProvider>
        </ReportsState>
      </AuthState>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
